function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function () {
        var self = this, args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { version } from '../../../package.json';
import window from 'global/window';
import document from 'global/document';
import jsonp from 'jsonp';
import * as browser from '@emav-util/browser.js';
import AVStatistic from './av-statistic';
import AVBigdataStatistic from './av-statistic-bigdata';
import {
    getChannelById,
    getChannelByUid
} from './av-channel';
var AVBizWrapper = function () {
    function AVBizWrapper(player, options) {
        _classCallCheck(this, AVBizWrapper);
        this.player = player;
        this.config = {
            env: options.env,
            statistic: options.statistic || {
                viewCount: true,
                activeTime: false,
                bd: undefined
            },
            bizWarn: options.bizWarn
        };
        console.log('[201911]#########################[AVBizWrapper][ctor] >>>', options, options.env, options.statistic);
        this.currentTime = options.currentTime;
        this.avInfo = {
            vid: undefined,
            fixed: undefined,
            name: '',
            is_live: false,
            is_foreshow: false,
            is_audio: false,
            state: -1,
            start_time: 0,
            foreshow_time: 0,
            end_time: 0,
            width: 0,
            height: 0,
            ui_state: undefined,
            poster: '',
            backWorkerInfo: {
                from: 0,
                balance: 0,
                currentVid: '',
                ended: false
            },
            seekInfo: {
                from: 0,
                to: 0
            }
        };
        this.avStatistic = new AVStatistic(this.config.env);
        this.avBigdataStatistic = new AVBigdataStatistic(this.config);
    }
    _createClass(AVBizWrapper, [
        {
            key: 'onFirstPlay',
            value: function onFirstPlay() {
                this.avInfo.backWorkerInfo = {
                    from: 0,
                    balance: 0,
                    currentVid: '',
                    ended: false
                };
                this.avInfo.seekInfo = {
                    from: 0,
                    to: 0
                };
                console.log('[201911]#########################[AVBizWrapper][onFirstPlay] >>>', this, this.avInfo);
            }
        },
        {
            key: 'onPlay',
            value: function onPlay() {
                console.log('[201911]#########################[AVBizWrapper][onPlay] >>>', this, this.avInfo);
            }
        },
        {
            key: 'onPause',
            value: function onPause() {
                console.log('[201911]#########################[AVBizWrapper][onPause] >>>', this, this.avInfo);
            }
        },
        {
            key: 'onSeeking',
            value: function onSeeking() {
                var currentTime = this.currentTime();
                this.avInfo.seekInfo.from = currentTime;
                console.log('[201911]#########################[AVBizWrapper][onSeeking] >>>', this, this.avInfo, currentTime, this.avInfo.seekInfo);
            }
        },
        {
            key: 'onSeeked',
            value: function onSeeked() {
                var currentTime = this.currentTime();
                console.log('[201911]#########################[AVBizWrapper][onSeeked] <<<', this, this.avInfo, currentTime, '(', this.avInfo.seekInfo, this.avInfo.backWorkerInfo.from, ') ==>', this.avInfo.backWorkerInfo.balance);
                this.avInfo.seekInfo.to = currentTime;
                this.avInfo.backWorkerInfo.from = currentTime;
                console.log('[201911]#########################[AVBizWrapper][onSeeked] >>>', this, this.avInfo, currentTime, '(', this.avInfo.seekInfo, this.avInfo.backWorkerInfo.from, ') ==>', this.avInfo.backWorkerInfo.balance);
            }
        },
        {
            key: 'onEnded',
            value: function onEnded() {
                var currentTime = this.currentTime();
                this.avActiveTimeStatistic(this.avInfo.vid, this.avInfo.backWorkerInfo.balance + currentTime - this.avInfo.backWorkerInfo.from);
                this.avInfo.backWorkerInfo.from = 0;
                this.avInfo.backWorkerInfo.balance = 0;
                this.avInfo.backWorkerInfo.ended = true;
                this.avInfo.seekInfo = {
                    from: 0,
                    to: 0
                };
                console.log('[201911]#########################[AVBizWrapper][onEnded] >>>', this, this.avInfo, currentTime);
            }
        },
        {
            key: 'backWorker',
            value: function backWorker() {
                console.log('[201911]#########################[AVBizWrapper][backWorker] >>>', this, this.avInfo, this.currentTime());
            }
        },
        {
            key: 'avActiveTimeStatistic',
            value: function () {
                var _avActiveTimeStatistic = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id, duration) {
                    var self;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                console.log('[AVBizWrapper][avActiveTimeStatistic]:', self.config, self.config.statistic, self.config.statistic.activeTime, duration);
                                if (!(self.config && self.config.statistic && !self.config.statistic.activeTime || duration <= 0)) {
                                    _context.next = 4;
                                    break;
                                }
                                return _context.abrupt('return');
                            case 4:
                                self.avDefaultActiveTimeStatistic(id, duration);
                                self.avBigdataActiveTimeStatistic(id, duration);
                            case 6:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
                function avActiveTimeStatistic(_x, _x2) {
                    return _avActiveTimeStatistic.apply(this, arguments);
                }
                return avActiveTimeStatistic;
            }()
        },
        {
            key: 'avDefaultActiveTimeStatistic',
            value: function () {
                var _avDefaultActiveTimeStatistic = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(id, duration) {
                    var self;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                            case 0:
                                self = this;
                                self.avStatistic.emavStatistic({
                                    type: 'activeTime',
                                    id: id,
                                    duration: duration
                                });
                            case 2:
                            case 'end':
                                return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
                function avDefaultActiveTimeStatistic(_x3, _x4) {
                    return _avDefaultActiveTimeStatistic.apply(this, arguments);
                }
                return avDefaultActiveTimeStatistic;
            }()
        },
        {
            key: 'avBigdataActiveTimeStatistic',
            value: function () {
                var _avBigdataActiveTimeStatistic = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(id, duration) {
                    var self;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                            case 0:
                                self = this;
                                self.avBigdataStatistic.avBigdataStatistic(id, duration, self.avInfo);
                            case 2:
                            case 'end':
                                return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));
                function avBigdataActiveTimeStatistic(_x5, _x6) {
                    return _avBigdataActiveTimeStatistic.apply(this, arguments);
                }
                return avBigdataActiveTimeStatistic;
            }()
        },
        {
            key: 'avViewCountStatistic',
            value: function () {
                var _avViewCountStatistic = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(id) {
                    var self;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                            case 0:
                                self = this;
                                self.avStatistic.emavStatistic({
                                    type: 'play',
                                    id: id
                                });
                            case 2:
                            case 'end':
                                return _context4.stop();
                            }
                        }
                    }, _callee4, this);
                }));
                function avViewCountStatistic(_x7) {
                    return _avViewCountStatistic.apply(this, arguments);
                }
                return avViewCountStatistic;
            }()
        },
        {
            key: 'fixBizSource',
            value: function () {
                var _fixBizSource = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(resource) {
                    var _this = this;
                    var currentTime, self, apiRes, fixed, vid, uid;
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                            switch (_context5.prev = _context5.next) {
                            case 0:
                                currentTime = this.currentTime();
                                console.log('[201911]#########################[AVBizWrapper][fixBizSource] >>>', '\r\n', this, '\r\n', this.avInfo, '\r\n(', currentTime, this.avInfo.backWorkerInfo.from, ')\r\n', resource);
                                try {
                                    if (this.avInfo.vid !== '' && !this.avInfo.backWorkerInfo.ended && currentTime > 0) {
                                        this.avActiveTimeStatistic(this.avInfo.vid, this.avInfo.backWorkerInfo.balance + currentTime - this.avInfo.backWorkerInfo.from);
                                    }
                                } catch (error) {
                                    console.log(error);
                                }
                                self = this;
                                fixed = false;
                                vid = '';
                                if (/^#+[0-9]*$/.test(resource)) {
                                    uid = resource.replace('#', '');
                                    apiRes = getChannelByUid(uid, self.config.env).then(function (channel) {
                                        console.log('浪客视频信息\uFF1A', channel, browser.IE_VERSION);
                                        self.toAVInfo(channel);
                                        vid = channel.id;
                                    });
                                    fixed = true;
                                } else if (/^[0-9]*$/.test(resource)) {
                                    apiRes = getChannelById(resource, self.config.env).then(function (channel) {
                                        console.log('浪客视频信息\uFF1A', channel, browser.IE_VERSION);
                                        self.toAVInfo(channel);
                                        vid = channel.id;
                                    });
                                    fixed = true;
                                } else {
                                    self.avInfo.url = resource;
                                    self.avInfo.size = 0;
                                    self.avInfo.duration = 0;
                                    self.avInfo.width = 0;
                                    self.avInfo.height = 0;
                                    vid = resource;
                                }
                                _context5.next = 9;
                                return Promise.all([apiRes]);
                            case 9:
                                if (fixed) {
                                    if (window.location.protocol === 'https:') {
                                        self.avInfo.url = self.avInfo.url.replace('http:', '');
                                    }
                                    self.refreshId = setInterval(function () {
                                        getChannelById(resource, _this.config.env).then(function (channel) {
                                            self.toAVInfo(channel);
                                            self.player.trigger('refreshstatus');
                                        });
                                    }, 5000);
                                }
                                self.avInfo.vid = vid;
                                self.avInfo.fixed = fixed;
                                self.avViewCountStatistic(vid);
                                console.log('选择兼容当前浏览器的音视频信息\uFF1A', self.avInfo);
                                return _context5.abrupt('return', self.avInfo);
                            case 15:
                            case 'end':
                                return _context5.stop();
                            }
                        }
                    }, _callee5, this);
                }));
                function fixBizSource(_x8) {
                    return _fixBizSource.apply(this, arguments);
                }
                return fixBizSource;
            }()
        },
        {
            key: 'stopRefresh',
            value: function stopRefresh() {
                var self = this;
                console.log('stopRefresh:', self.refreshId);
                if (self.refreshId) {
                    clearInterval(self.refreshId);
                }
            }
        },
        {
            key: 'toAVInfo',
            value: function toAVInfo(channel) {
                var self = this;
                if (channel.is_live) {
                    self.avInfo.url = channel.hls;
                    self.avInfo.size = 0;
                    self.avInfo.duration = 0;
                } else if (channel.del_state === 1) {
                } else if (channel.is_foreshow) {
                    self.avInfo.is_foreshow = true;
                    self.avInfo.url = '';
                    self.avInfo.size = 0;
                    self.avInfo.duration = 0;
                } else {
                    if (null !== browser.IE_VERSION && channel.mp4.length > 0) {
                        self.avInfo.url = channel.mp4[0].url;
                        self.avInfo.size = channel.mp4[0].size;
                        self.avInfo.duration = channel.mp4[0].duration;
                    } else {
                        if (channel.isAudio) {
                            self.avInfo.url = channel.audio[0].url;
                            self.avInfo.size = channel.audio[0].size;
                            self.avInfo.duration = channel.audio[0].duration;
                        } else {
                            self.avInfo.url = channel.hls[0].url;
                            self.avInfo.size = channel.hls[0].size;
                            self.avInfo.duration = channel.hls[0].duration;
                        }
                    }
                }
                self.avInfo.name = channel.name;
                self.avInfo.is_live = channel.is_live;
                self.avInfo.is_audio = channel.isAudio;
                self.avInfo.start_time = channel.start_time;
                self.avInfo.foreshow_time = channel.foreshow_time;
                self.avInfo.end_time = channel.end_time;
                self.avInfo.poster = channel.poster;
                self.avInfo.state = channel.state;
                self.avInfo.ui_state = channel.ui_state;
                self.avInfo.width = channel.width;
                self.avInfo.height = channel.height;
            }
        }
    ]);
    return AVBizWrapper;
}();
export {
    AVBizWrapper as default
};